import React, { Component } from 'react'
import _ from 'lodash'
import { t } from 'i18n'

import AddressApi from '../../../api/Patient/Address'

import Address from '../FormFields/Address';

const i18nOpts = { scope: 'patient.new.address' }

class AddressForm extends Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleErrors = this.handleErrors.bind(this)

    this.state = {
      address: {
        label: 'home',
        address: '',
        extendedAddress: '',
        city: '',
        region: '',
        postalCode: '',
        countryCode: 'CA',
      },
      errors: {},
    }
  }

  handleChange({ target: { name, value } }) {
    if (name == 'address.countryCode' && value == 'GB') {
      this.setState((prevState) => ({
        ...prevState,
        address: {
          ...prevState.address,
          region: '',
          countryCode: value
        }
      }))
    } else {
      this.setState((prevState) => _.set(prevState, name, value))
    }
  }

  handleSubmit(evt) {
    evt.preventDefault()
    const { carePlanUuid, onSuccess } = this.props
    const { address } = this.state

    new AddressApi(carePlanUuid).create(address).then((res) => {
      if (res.ok) {
        res.json().then(onSuccess)
      } else if (res.status === 422) {
        res.json().then(this.handleErrors)
      }
    })
  }

  handleErrors(errors) {
    this.setState({ errors })
  }

  render() {
    const { address, errors } = this.state
    const { locale } = this.props;

    return (
      <form className="form form--background" onSubmit={this.handleSubmit}>
        <Address
          address={address}
          name='address'
          locale={locale}
          onChange={this.handleChange}
          formErrors={errors}
        />

        <div className="form__submit">
          <input className='btn' type="submit" value={t('save', i18nOpts)} />
        </div>
      </form>
    )
  }
}

export default AddressForm;
